import { Authority } from '@/shared/security/authority';
import { Role } from '@/shared/model/enumerations/role.model';
import { Access } from '@/shared/model/enumerations/access.model';
/* tslint:disable */
// prettier-ignore

// prettier-ignore
const Company = () => import('@/entities/company/company.vue');
// prettier-ignore
const CompanyUpdate = () => import('@/entities/company/company-update.vue');
// prettier-ignore
const CompanyDetails = () => import('@/entities/company/company-details.vue');
// prettier-ignore
const Shop = () => import('@/entities/shop/shop.vue');
// prettier-ignore
const ShopUpdate = () => import('@/entities/shop/shop-update.vue');
// prettier-ignore
const ShopDetails = () => import('@/entities/shop/shop-details.vue');
// prettier-ignore
const ShopEmailTemplate = () => import('@/entities/shop-email-template/shop-email-template.vue');
// prettier-ignore
// const ShopEmailTemplateUpdate = () => import('@/entities/shop-email-template/shop-email-template-update.vue');
const ShopEmailTemplateUpdate = () => import('@/entities/shop/shop-email-template-update.vue');
// prettier-ignore
const ShopEmailTemplateDetails = () => import('@/entities/shop-email-template/shop-email-template-details.vue');
// prettier-ignore
const UserAccess = () => import('@/entities/user-access/user-access.vue');
// prettier-ignore
const UserAccessUpdate = () => import('@/entities/user-access/user-access-update.vue');
// prettier-ignore
const UserAccessDetails = () => import('@/entities/user-access/user-access-details.vue');
// prettier-ignore
const UserCompany = () => import('@/entities/user-company/user-company.vue');
// prettier-ignore
const UserCompanyUpdate = () => import('@/entities/user-company/user-company-update.vue');
// prettier-ignore
const UserCompanyDetails = () => import('@/entities/user-company/user-company-details.vue');
// prettier-ignore
const UserShop = () => import('@/entities/user-shop/user-shop.vue');
// prettier-ignore
const UserShopUpdate = () => import('@/entities/user-shop/user-shop-update.vue');
// prettier-ignore
const UserShopDetails = () => import('@/entities/user-shop/user-shop-details.vue');
// prettier-ignore
const ProductType = () => import('@/entities/product-type/product-type.vue');
// prettier-ignore
const ProductTypeUpdate = () => import('@/entities/product-type/product-type-update.vue');
// prettier-ignore
const ProductTypeDetails = () => import('@/entities/product-type/product-type-details.vue');
// prettier-ignore
const Product = () => import('@/entities/product/product.vue');
// prettier-ignore
const ProductUpdate = () => import('@/entities/product/product-update.vue');
// prettier-ignore
const ProductDetails = () => import('@/entities/product/product-details.vue');
// prettier-ignore
const Order = () => import('@/entities/order/order.vue');
// prettier-ignore
const OrderUpdate = () => import('@/entities/order/order-update.vue');
// prettier-ignore
const OrderDetails = () => import('@/entities/order/order-details.vue');
// prettier-ignore
const OrderItem = () => import('@/entities/order-item/order-item.vue');
// prettier-ignore
const OrderItemUpdate = () => import('@/entities/order-item/order-item-update.vue');
// prettier-ignore
const OrderItemDetails = () => import('@/entities/order-item/order-item-details.vue');
// prettier-ignore
const ShopSmtp = () => import('@/entities/shop-smtp/shop-smtp.vue');
// prettier-ignore
const ShopSmtpUpdate = () => import('@/entities/shop-smtp/shop-smtp-update.vue');
// prettier-ignore
const ShopSmtpDetails = () => import('@/entities/shop-smtp/shop-smtp-details.vue');
// prettier-ignore
const ShopApprovalRule = () => import('@/entities/shop-approval-rule/shop-approval-rule.vue');
// prettier-ignore
const ShopApprovalRuleUpdate = () => import('@/entities/shop-approval-rule/shop-approval-rule-update.vue');
// prettier-ignore
const ShopApprovalRuleDetails = () => import('@/entities/shop-approval-rule/shop-approval-rule-details.vue');
const ShopEmailTemplateList = () => import('@/entities/shop/shop-email-template-list.vue');
const ShopEmailTemplateUpdateNew = () => import('@/entities/shop/shop-email-template-update-new.vue');
const Notifications = () => import('@/entities/notifications/notifications.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default [
  {
    path: '/shop-email-template/:shopId?/list',
    name: 'ShopEmailTemplateList',
    component: ShopEmailTemplateList,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-email-template/:shopId?/:identifier/:title/:multiLang',
    name: 'ShopEmailTemplateUpdateNew',
    component: ShopEmailTemplateUpdateNew,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/company',
    name: 'Company',
    component: Company,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY] },
  },
  {
    path: '/company/new',
    name: 'CompanyCreate',
    component: CompanyUpdate,
    meta: { authorities: [Authority.USER, Access.COMPANY] },
  },
  {
    path: '/company/:companyId/edit',
    name: 'CompanyEdit',
    component: CompanyUpdate,
    meta: { authorities: [Authority.USER, Access.COMPANY] },
  },
  {
    path: '/company/:companyId/view',
    name: 'CompanyView',
    component: CompanyDetails,
    meta: { authorities: [Authority.USER, Access.COMPANY] },
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop/new',
    name: 'ShopCreate',
    component: ShopUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY] },
  },
  {
    path: '/shop/:shopId/edit',
    name: 'ShopEdit',
    component: ShopUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop/:shopId/view',
    name: 'ShopView',
    component: ShopDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-email-template',
    name: 'ShopEmailTemplate',
    component: ShopEmailTemplate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-email-template/new',
    name: 'ShopEmailTemplateCreate',
    component: ShopEmailTemplateUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-email-template/:shopId?/edit',
    name: 'ShopEmailTemplateEdit',
    component: ShopEmailTemplateUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-email-template/:shopEmailTemplateId/view',
    name: 'ShopEmailTemplateView',
    component: ShopEmailTemplateDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/user-access',
    name: 'UserAccess',
    component: UserAccess,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY] },
  },
  {
    path: '/user-access/new',
    name: 'UserAccessCreate',
    component: UserAccessUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY] },
  },
  {
    path: '/user-access/:userAccessId/edit',
    name: 'UserAccessEdit',
    component: UserAccessUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY] },
  },
  {
    path: '/user-access/:userAccessId/view',
    name: 'UserAccessView',
    component: UserAccessDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY] },
  },
  {
    path: '/user-company',
    name: 'UserCompany',
    component: UserCompany,
    meta: { authorities: [Authority.USER, Access.COMPANY] },
  },
  {
    path: '/user-company/new',
    name: 'UserCompanyCreate',
    component: UserCompanyUpdate,
    meta: { authorities: [Authority.USER, Access.COMPANY] },
  },
  {
    path: '/user-company/:userCompanyId/edit',
    name: 'UserCompanyEdit',
    component: UserCompanyUpdate,
    meta: { authorities: [Authority.USER, Access.COMPANY] },
  },
  {
    path: '/user-company/:userCompanyId/view',
    name: 'UserCompanyView',
    component: UserCompanyDetails,
    meta: { authorities: [Authority.USER, Access.COMPANY] },
  },
  {
    path: '/user-shop',
    name: 'UserShop',
    component: UserShop,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.SHOP] },
  },
  {
    path: '/user-shop/new',
    name: 'UserShopCreate',
    component: UserShopUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.SHOP] },
  },
  {
    path: '/user-shop/:userShopId/edit',
    name: 'UserShopEdit',
    component: UserShopUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.SHOP] },
  },
  {
    path: '/user-shop/:userShopId/view',
    name: 'UserShopView',
    component: UserShopDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.SHOP] },
  },
  {
    path: '/product-type',
    name: 'ProductType',
    component: ProductType,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/product-type/new',
    name: 'ProductTypeCreate',
    component: ProductTypeUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/product-type/:productTypeId/edit',
    name: 'ProductTypeEdit',
    component: ProductTypeUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/product-type/:productTypeId/view',
    name: 'ProductTypeView',
    component: ProductTypeDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/product',
    name: 'Product',
    component: Product,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/product/new',
    name: 'ProductCreate',
    component: ProductUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/product/:productId/edit',
    name: 'ProductEdit',
    component: ProductUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/product/:productId/view',
    name: 'ProductView',
    component: ProductDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    meta: { authorities: [Authority.USER, Role.EMPLOYEE, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order/new',
    name: 'OrderCreate',
    component: OrderUpdate,
    meta: { authorities: [Authority.USER, Role.EMPLOYEE, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order/:orderId/edit',
    name: 'OrderEdit',
    component: OrderUpdate,
    meta: { authorities: [Authority.USER, Role.EMPLOYEE, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order/:orderId/view',
    name: 'OrderView',
    component: OrderDetails,
    meta: { authorities: [Authority.USER, Role.EMPLOYEE, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order-item',
    name: 'OrderItem',
    component: OrderItem,
    meta: { authorities: [Authority.USER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order-item/new',
    name: 'OrderItemCreate',
    component: OrderItemUpdate,
    meta: { authorities: [Authority.USER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order-item/:orderItemId/edit',
    name: 'OrderItemEdit',
    component: OrderItemUpdate,
    meta: { authorities: [Authority.USER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/order-item/:orderItemId/view',
    name: 'OrderItemView',
    component: OrderItemDetails,
    meta: { authorities: [Authority.USER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-smtp',
    name: 'ShopSmtp',
    component: ShopSmtp,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-smtp/new',
    name: 'ShopSmtpCreate',
    component: ShopSmtpUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-smtp/:shopSmtpId/edit',
    name: 'ShopSmtpEdit',
    component: ShopSmtpUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-smtp/:shopId/',
    name: 'ShopSmtpUpdate',
    component: ShopSmtpUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-smtp/:shopSmtpId/view',
    name: 'ShopSmtpView',
    component: ShopSmtpDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-approval-rule',
    name: 'ShopApprovalRule',
    component: ShopApprovalRule,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-approval-rule/new',
    name: 'ShopApprovalRuleCreate',
    component: ShopApprovalRuleUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-approval-rule/:shopApprovalRuleId/edit',
    name: 'ShopApprovalRuleEdit',
    component: ShopApprovalRuleUpdate,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/shop-approval-rule/:shopApprovalRuleId/view',
    name: 'ShopApprovalRuleView',
    component: ShopApprovalRuleDetails,
    meta: { authorities: [Authority.USER, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { authorities: [Authority.USER, Role.EMPLOYEE, Role.MANAGER, Access.COMPANY, Access.SHOP] },
  },
  // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
];
